import { FC } from "react";
import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  SxProps,
  Theme,
} from "@mui/material";

// The Ask Reve violet gradient, shared by every Ask Reve-styled control.
export const violetGradient = (theme: Theme) =>
  `linear-gradient(87.38deg, ${theme.palette.custom.violetGradientStart} 0.42%, ${theme.palette.custom.violetGradientMid} 100%)`;

export const violetGradientHover = (theme: Theme) =>
  `linear-gradient(135deg, ${theme.palette.custom.violetGradientHover}, ${theme.palette.custom.violetMain})`;

const gradientSx: SxProps<Theme> = (theme) => ({
  background: violetGradient(theme),
  "&:hover": {
    background: violetGradientHover(theme),
  },
  "&.Mui-disabled": {
    background: "none",
    backgroundColor: "grey.300",
  },
});

// Puts the caller's sx after the gradient so per-call-site sizing/shape can override it.
const withGradientSx = (sx?: SxProps<Theme>): SxProps<Theme> => [
  gradientSx,
  ...(Array.isArray(sx) ? sx : [sx]),
];

/** MUI Button with the Ask Reve gradient background. */
export const GradientButton: FC<ButtonProps> = ({ sx, ...props }) => (
  <Button
    {...props}
    sx={withGradientSx([
      {
        textTransform: "none",
        color: "primary.contrastText",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ])}
  />
);

/** MUI IconButton (round) with the Ask Reve gradient background, e.g. send buttons. */
export const GradientIconButton: FC<IconButtonProps> = ({ sx, ...props }) => (
  <IconButton
    {...props}
    sx={withGradientSx([
      { flexShrink: 0, borderRadius: "100%" },
      ...(Array.isArray(sx) ? sx : [sx]),
    ])}
  />
);
